import { GET_LOGIN_JWT } from "uniba-volto-jwtsession/actions";


const initialState = {
    error: null,
    items: [],
    total: 0,
    loaded: false,
    loading: false,
    batching: {},
    subrequests: {},
};

/**
 * login JWT reducer.
 * @function loginJwtReducer
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function loginJwtReducer(state = initialState, action = {}) {
    switch (action.type) {
        case `${GET_LOGIN_JWT}_PENDING`:
            return {
                ...state,
                loadingResults: true,
            };

        case `${GET_LOGIN_JWT}_SUCCESS`:
            return {
                ...state,
                result: action.result,
                loadingResults: false,
            };

        case `${GET_LOGIN_JWT}_FAIL`:
            return {
                ...state,
                error: action.error,
                hasError: true,
                loadingResults: false,
            };

        default:
            return state;
    }
};
